<template>
    <div>
        <!-- DIALOG DE LOADING -->
        <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: .5em" />
            <div
                class="scalein animation-duration-2000 animation-iteration-infinite flex align-items-center justify-content-center font-bold border-round m-2 px-5 py-3">
                {{ loadingMensaje }}</div>
        </Dialog>

        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">Trabajador</h1>
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-save" class="p-button-rounded p-button-success p-button-outlined" @click="PostTrabajador()" />
                </div>
            </div>
            <hr size=7 color="#ED6421">
        </div>
        <br>
        <div class="card">
            <div class="p-d-flex justify-center p-fluid grid formgrid col-12">
                <!-- NOMBRE -->
                <div class="field col-12">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.nombre" type="text" />
                        <label>Nombre</label>
                    </span>
                </div>
                <!-- RFC -->
                <div class="field col-12 md:col-6">
                    <div class="p-inputgroup">
                        <span class="p-float-label">
                            <InputText v-model="trabajador.rfc" type="text" maxlength="13"/>
                            <label>RFC</label>
                        </span>
                        <template v-if="rfcValido == -1">
                            <Button icon="pi pi-replay" class="p-button-outlined  p-button-outlined p-button-info" />
                        </template>
                        <template v-if="rfcValido == 1">
                            <Button icon="pi pi-check" class="p-button-outlined  p-button-outlined p-button-success" />
                        </template>
                        <template v-if="rfcValido == 0">
                            <Button icon="pi pi-times" class="p-button-outlined  p-button-outlined p-button-danger" />
                        </template>
                    </div>
                </div>
                <!-- CURP -->
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.curp" type="text" maxlength="18"/>
                        <label>CURP</label>
                    </span>
                </div>
                <!-- TIPO REGIMEN -->
                <div class="field col-12">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="trabajador.tipoRegimen" :options="tipoRegimen" optionLabel="tipoRegimen" />
                        <label>Tipo de Régimen</label>
                    </span>
                </div>
                <!-- TIPO JORNADA -->
                <template v-if="trabajador.tipoRegimen.clave==='02'">
                    <div class="field col-12">
                        <span class="p-float-label">
                            <Dropdown style="text-align: left" v-model="trabajador.tipoJornada" :options="tipoJornada" optionLabel="tipoJornada" />
                            <label>Tipo de Jornada</label>
                        </span>
                    </div>
                </template>
                <!-- NUMERO SEGURIDAD SOCIAL -->
                <template v-if="trabajador.tipoRegimen.clave==='02'">
                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <InputText v-model="trabajador.numSeguridadSocial" type="text" />
                            <label>Num. Seguridad Social</label>
                        </span>
                    </div>
                </template>
                <!-- FECHA INICIO REL LABORAL -->
                <template v-if="trabajador.tipoRegimen.clave==='02'">
                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <Calendar v-model="trabajador.fechaInicioRelLaboral" dateFormat="dd-MM-yy" />
                            <label>Fecha Inicio Rel Laboral</label>
                        </span>
                    </div>
                </template>
                <!-- TIPO CONTRATO -->
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="trabajador.tipoContrato" :options="tipoContrato" optionLabel="tipoContrato" />
                        <label>Tipo de Contrato</label>
                    </span>
                </div>
                <!-- SINDICALIZADO -->
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="trabajador.sindicalizado" :options="sindicalizado" />
                        <label>Sindicalizado</label>
                    </span>
                </div>
                <!-- NUM . EMPLEADO -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.numEmpleado" type="text" />
                        <label>Num. Empleado</label>
                    </span>
                </div>
                <!-- DEPARTAMENTO -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.departamento" type="text" />
                        <label>Departamento</label>
                    </span>
                </div>
                <!-- PUESTO -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.puesto" type="text" />
                        <label>Puesto</label>
                    </span>
                </div>
                <!-- RIESGO DE PUESTO -->
                <template v-if="trabajador.tipoRegimen.clave==='02'">
                    <div class="field col-12 md:col-6">
                        <span class="p-float-label">
                            <Dropdown style="text-align: left" v-model="trabajador.riesgoPuesto" :options="riesgoPuesto" optionLabel="riesgoPuesto" />
                            <label>Riesgo de Puesto</label>
                        </span>
                    </div>
                </template>
                <!-- PERIODICIDAD DE PAGO -->
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="trabajador.periodicidadPago" :options="periodicidadPago" optionLabel="periodicidadPago" />
                        <label>Periodicidad de Pago</label>
                    </span>
                </div>
                <!-- BANCO -->
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="trabajador.banco" :options="banco" optionLabel="banco" />
                        <label>Banco</label>
                    </span>
                </div>
                <!-- CUENTA BANCARIA -->
                <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.cuentaBancaria" type="text" />
                        <label>cuentaBancaria</label>
                    </span>
                </div>
                <!-- SALARIO BASE COT APOR -->
                <template v-if="trabajador.tipoRegimen.clave==='02'">
                    <div class="justify-right field col-12 md:col-4">
                        <span class="p-float-label">
                            <InputNumber v-model="trabajador.salarioBaseCotApor" mode="decimal" locale="en-US" :minFractionDigits="3" />
                            <label>Salario Base Cot Apor</label>
                        </span>
                    </div>
                </template>
                <!-- SALARIO DIARIO INTEGRADO -->
                <template v-if="trabajador.tipoRegimen.clave==='02'">
                    <div class="justify-right field col-12 md:col-4">
                        <span class="p-float-label">
                            <InputNumber v-model="trabajador.salarioDiarioIntegrado" mode="decimal" locale="en-US" :minFractionDigits="3" />
                            <label>Salario Diario Integrado</label>
                        </span>
                    </div>
                </template>
                <!-- CLAVE ENT FED -->
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <Dropdown style="text-align: left" v-model="trabajador.claveEntFed" :options="claveEntFed" optionLabel="claveEntFed" />
                        <label>claveEntFed</label>
                    </span>
                </div>
                <!-- CODIGO POSTAL -->
                <div class="field col-12 md:col-2">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.cp" type="text" />
                        <label>Código Postal</label>
                    </span>
                </div>
                <!-- CORREO -->
                <div class="field col-12 md:col-12">
                    <span class="p-float-label">
                        <InputText v-model="trabajador.correo" type="text" />
                        <label>Correo</label>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'

    export default {
        components: {

        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',

            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            trabajador(){
                return this.$store.state.trabajadorStore;
            },

            sindicalizado(){
                let s = [ 'Sí', 'No', 'NA' ]
                return s;
            },
            tipoContrato(){
                return this.$store.state.tipoContratoStore;
            },
            tipoJornada(){
                return this.$store.state.tipoJornadaStore;
            },
            tipoRegimen(){
                return this.$store.state.tipoRegimenStore;
            },
            riesgoPuesto(){
                return this.$store.state.riesgoPuestoStore;
            },
            periodicidadPago(){
                return this.$store.state.periodicidadPagoStore;
            },
            banco(){
                return this.$store.state.bancoStore;
            },
            claveEntFed(){
                return this.$store.state.claveEntFedStore;
            },
        
            rfcValido() {
                let rfc= this.trabajador.rfc;
                let aceptarGenerico= true;
                if(rfc.length < 11){
                    return -1;
                }

                const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
                var validado = rfc.match(re);

                if (!validado)  // Coincide con el formato general del regex?
                    return false;

                // Separar el dígito verificador del resto del RFC
                const digitoVerificador = validado.pop(),
                    rfcSinDigito = validado.slice(1).join(''),
                    len = rfcSinDigito.length,

                    // Obtener el digito esperado
                    diccionario = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ",
                    indice = len + 1;
                var suma,
                    digitoEsperado;

                if (len == 12) suma = 0
                else suma = 481; // Ajuste para persona moral

                for (var i = 0; i < len; i++)
                    suma += diccionario.indexOf(rfcSinDigito.charAt(i)) * (indice - i);
                digitoEsperado = 11 - suma % 11;
                if (digitoEsperado == 11) digitoEsperado = 0;
                else if (digitoEsperado == 10) digitoEsperado = "A";

                // El dígito verificador coincide con el esperado?
                // o es un RFC Genérico (ventas a público general)?
                if ((digitoVerificador != digitoEsperado)
                    && (!aceptarGenerico || rfcSinDigito + digitoVerificador != "XAXX010101000")){
                        this.resultRfc = 0;
                        return false;
                    }
                else if (!aceptarGenerico && rfcSinDigito + digitoVerificador == "XEXX010101000"){
                    this.resultRfc = 0;
                    return false;
                }
                console.log(rfcSinDigito + digitoVerificador)
                this.resultRfc = 1;
                return true;
            },

        },
        created() {
            
        },
        methods: {
            async PostTrabajador(){
                try{
                    this.loading = true;
                    this.loadingMensaje = 'Guardando trabajador...'
                    let ObjTrabajador = {}
                    ObjTrabajador = { ...this.trabajador };
                    let respuesta = await axios.post("Nomina/PostTrabajador/" + this.token.empresaBase, ObjTrabajador);
                    let x =  respuesta.data;
                    ObjTrabajador.id = x;
                    this.$store.state.trabajadoresStore.push(ObjTrabajador);
                    this.cierraVentana();
                }catch(error){
                    this.loading = false;
                    console.log(error);
                }
            },

            cierraVentana(){
                this.$emit('closeDialogTrabajador')
            },


        },
    }
    </script>
    <style>
    </style>